/** Auto-generated from open-table-data/*.csv — do not hand-edit. */
export const OPENTABLE_WINDOW_LABEL = 'May 2025';

export type OpenTableOutletAggregate = {
  name: string;
  normalizedName: string;
  totalGroups: number;
  covers: number;
  placedGroups: number;
  reservations: number;
  avgParty: number;
  noshowRate: number;
  cancelRate: number;
};

export type OpenTableCohortAggregate = {
  outletCount: number;
  covers: number;
  placedGroups: number;
  reservations: number;
  avgParty: number;
  noshowRate: number;
  cancelRate: number;
};

export const OPENTABLE_OUTLETS: OpenTableOutletAggregate[] = [
  {
    "name": "L'Osteria Frankfurt Hanauer Landstrasse",
    "normalizedName": "l'osteria frankfurt hanauer landstrasse",
    "totalGroups": 1058,
    "covers": 4434,
    "placedGroups": 1018,
    "reservations": 1018,
    "avgParty": 4.16,
    "noshowRate": 1.23,
    "cancelRate": 2.55
  },
  {
    "name": "L'Osteria Frankfurt Junghofstrasse",
    "normalizedName": "l'osteria frankfurt junghofstrasse",
    "totalGroups": 1311,
    "covers": 5406,
    "placedGroups": 1190,
    "reservations": 1190,
    "avgParty": 4.01,
    "noshowRate": 2.75,
    "cancelRate": 6.48
  },
  {
    "name": "L'Osteria Frankfurt MyZeil",
    "normalizedName": "l'osteria frankfurt myzeil",
    "totalGroups": 763,
    "covers": 2706,
    "placedGroups": 710,
    "reservations": 710,
    "avgParty": 3.54,
    "noshowRate": 0.26,
    "cancelRate": 6.68
  },
  {
    "name": "L'Osteria Frankfurt Speicherstraße",
    "normalizedName": "l'osteria frankfurt speicherstraße",
    "totalGroups": 1054,
    "covers": 5370,
    "placedGroups": 880,
    "reservations": 880,
    "avgParty": 5.1,
    "noshowRate": 6.45,
    "cancelRate": 10.06
  },
  {
    "name": "L'Osteria Günzburg Wilhelm-Maybach-Straße",
    "normalizedName": "l'osteria günzburg wilhelm-maybach-straße",
    "totalGroups": 921,
    "covers": 4069,
    "placedGroups": 854,
    "reservations": 854,
    "avgParty": 4.32,
    "noshowRate": 1.19,
    "cancelRate": 6.08
  },
  {
    "name": "L'Osteria Ingolstadt",
    "normalizedName": "l'osteria ingolstadt",
    "totalGroups": 763,
    "covers": 2991,
    "placedGroups": 703,
    "reservations": 703,
    "avgParty": 3.81,
    "noshowRate": 0.26,
    "cancelRate": 7.6
  },
  {
    "name": "L'Osteria Magdeburg Ernst-Reuter-Allee",
    "normalizedName": "l'osteria magdeburg ernst-reuter-allee",
    "totalGroups": 2259,
    "covers": 6989,
    "placedGroups": 2054,
    "reservations": 2054,
    "avgParty": 3.1,
    "noshowRate": 3.32,
    "cancelRate": 5.75
  },
  {
    "name": "L'Osteria München Künstlerhaus",
    "normalizedName": "l'osteria münchen künstlerhaus",
    "totalGroups": 3317,
    "covers": 11958,
    "placedGroups": 3078,
    "reservations": 3078,
    "avgParty": 3.58,
    "noshowRate": 0.18,
    "cancelRate": 7.02
  },
  {
    "name": "L'Osteria Neutraubling Pommernstraße",
    "normalizedName": "l'osteria neutraubling pommernstraße",
    "totalGroups": 1192,
    "covers": 4820,
    "placedGroups": 1148,
    "reservations": 1148,
    "avgParty": 4.05,
    "noshowRate": 0,
    "cancelRate": 3.69
  },
  {
    "name": "L´Osteria Berlin AM TACHELES",
    "normalizedName": "l'osteria berlin am tacheles",
    "totalGroups": 910,
    "covers": 3407,
    "placedGroups": 846,
    "reservations": 846,
    "avgParty": 3.6,
    "noshowRate": 1.1,
    "cancelRate": 5.93
  },
  {
    "name": "L'Osteria Aachen Gut-Dämme-Straße",
    "normalizedName": "l'osteria aachen gut-dämme-straße",
    "totalGroups": 2283,
    "covers": 9145,
    "placedGroups": 2086,
    "reservations": 2086,
    "avgParty": 4.01,
    "noshowRate": 0,
    "cancelRate": 8.63
  },
  {
    "name": "L'Osteria Aachen Kapuzinergraben",
    "normalizedName": "l'osteria aachen kapuzinergraben",
    "totalGroups": 1321,
    "covers": 4806,
    "placedGroups": 1229,
    "reservations": 1229,
    "avgParty": 3.62,
    "noshowRate": 1.21,
    "cancelRate": 5.75
  },
  {
    "name": "L'Osteria APZ Bonn UN Campus",
    "normalizedName": "l'osteria apz bonn un campus",
    "totalGroups": 1330,
    "covers": 4932,
    "placedGroups": 1268,
    "reservations": 1268,
    "avgParty": 3.62,
    "noshowRate": 0.6,
    "cancelRate": 4.06
  },
  {
    "name": "L'Osteria Belval",
    "normalizedName": "l'osteria belval",
    "totalGroups": 447,
    "covers": 1822,
    "placedGroups": 412,
    "reservations": 412,
    "avgParty": 4.15,
    "noshowRate": 0.22,
    "cancelRate": 7.61
  },
  {
    "name": "L'Osteria Bonn in der Sürst",
    "normalizedName": "l'osteria bonn in der sürst",
    "totalGroups": 1064,
    "covers": 3732,
    "placedGroups": 1011,
    "reservations": 1011,
    "avgParty": 3.43,
    "noshowRate": 0.66,
    "cancelRate": 4.32
  },
  {
    "name": "L'Osteria Bonn Rheinwerk",
    "normalizedName": "l'osteria bonn rheinwerk",
    "totalGroups": 1692,
    "covers": 7979,
    "placedGroups": 1516,
    "reservations": 1516,
    "avgParty": 4.72,
    "noshowRate": 0.12,
    "cancelRate": 10.28
  },
  {
    "name": "L'Osteria Bornheim",
    "normalizedName": "l'osteria bornheim",
    "totalGroups": 1217,
    "covers": 5262,
    "placedGroups": 1123,
    "reservations": 1123,
    "avgParty": 4.37,
    "noshowRate": 0,
    "cancelRate": 7.72
  },
  {
    "name": "L'Osteria Castrop Rauxel",
    "normalizedName": "l'osteria castrop rauxel",
    "totalGroups": 721,
    "covers": 3145,
    "placedGroups": 650,
    "reservations": 650,
    "avgParty": 4.38,
    "noshowRate": 0.14,
    "cancelRate": 9.71
  },
  {
    "name": "L'Osteria Dormagen",
    "normalizedName": "l'osteria dormagen",
    "totalGroups": 1005,
    "covers": 4714,
    "placedGroups": 923,
    "reservations": 923,
    "avgParty": 4.67,
    "noshowRate": 0.8,
    "cancelRate": 7.36
  },
  {
    "name": "L'Osteria Düren",
    "normalizedName": "l'osteria düren",
    "totalGroups": 1896,
    "covers": 6955,
    "placedGroups": 1670,
    "reservations": 1670,
    "avgParty": 3.66,
    "noshowRate": 5.43,
    "cancelRate": 6.49
  },
  {
    "name": "L'Osteria Düsseldorf Berliner Allee",
    "normalizedName": "l'osteria düsseldorf berliner allee",
    "totalGroups": 883,
    "covers": 3866,
    "placedGroups": 790,
    "reservations": 790,
    "avgParty": 4.36,
    "noshowRate": 0.23,
    "cancelRate": 10.31
  },
  {
    "name": "L'Osteria Düsseldorf Jahnstraße",
    "normalizedName": "l'osteria düsseldorf jahnstraße",
    "totalGroups": 667,
    "covers": 2892,
    "placedGroups": 614,
    "reservations": 614,
    "avgParty": 4.36,
    "noshowRate": 0.3,
    "cancelRate": 7.65
  },
  {
    "name": "L'Osteria Düsseldorf Theodorstraße",
    "normalizedName": "l'osteria düsseldorf theodorstraße",
    "totalGroups": 1629,
    "covers": 7204,
    "placedGroups": 1488,
    "reservations": 1488,
    "avgParty": 4.44,
    "noshowRate": 0.43,
    "cancelRate": 8.23
  },
  {
    "name": "L'Osteria Erftstadt",
    "normalizedName": "l'osteria erftstadt",
    "totalGroups": 1050,
    "covers": 4158,
    "placedGroups": 972,
    "reservations": 972,
    "avgParty": 3.93,
    "noshowRate": 0.57,
    "cancelRate": 6.86
  },
  {
    "name": "L'Osteria Euskirchen",
    "normalizedName": "l'osteria euskirchen",
    "totalGroups": 982,
    "covers": 4140,
    "placedGroups": 881,
    "reservations": 881,
    "avgParty": 4.27,
    "noshowRate": 1.53,
    "cancelRate": 8.76
  },
  {
    "name": "L'Osteria Gelsenkirchen",
    "normalizedName": "l'osteria gelsenkirchen",
    "totalGroups": 1216,
    "covers": 4829,
    "placedGroups": 1093,
    "reservations": 1093,
    "avgParty": 3.99,
    "noshowRate": 0.41,
    "cancelRate": 9.7
  },
  {
    "name": "L'Osteria Hürth",
    "normalizedName": "l'osteria hürth",
    "totalGroups": 2398,
    "covers": 9145,
    "placedGroups": 2168,
    "reservations": 2168,
    "avgParty": 3.77,
    "noshowRate": 3.75,
    "cancelRate": 5.84
  },
  {
    "name": "L'Osteria Kaiserslautern",
    "normalizedName": "l'osteria kaiserslautern",
    "totalGroups": 1765,
    "covers": 7671,
    "placedGroups": 1604,
    "reservations": 1604,
    "avgParty": 4.35,
    "noshowRate": 0.51,
    "cancelRate": 8.61
  },
  {
    "name": "L'Osteria Kirchberg",
    "normalizedName": "l'osteria kirchberg",
    "totalGroups": 851,
    "covers": 3395,
    "placedGroups": 781,
    "reservations": 781,
    "avgParty": 3.92,
    "noshowRate": 0,
    "cancelRate": 8.23
  },
  {
    "name": "L'Osteria Kleve",
    "normalizedName": "l'osteria kleve",
    "totalGroups": 1336,
    "covers": 4783,
    "placedGroups": 1255,
    "reservations": 1255,
    "avgParty": 3.6,
    "noshowRate": 0.15,
    "cancelRate": 5.91
  },
  {
    "name": "L'Osteria Koblenz",
    "normalizedName": "l'osteria koblenz",
    "totalGroups": 976,
    "covers": 4639,
    "placedGroups": 858,
    "reservations": 858,
    "avgParty": 4.88,
    "noshowRate": 1.23,
    "cancelRate": 10.86
  },
  {
    "name": "L'Osteria Köln Deutz",
    "normalizedName": "l'osteria köln deutz",
    "totalGroups": 1421,
    "covers": 5443,
    "placedGroups": 1280,
    "reservations": 1280,
    "avgParty": 3.84,
    "noshowRate": 0.63,
    "cancelRate": 9.29
  },
  {
    "name": "L'Osteria Köln Gürzenich-Quartier",
    "normalizedName": "l'osteria köln gürzenich-quartier",
    "totalGroups": 1721,
    "covers": 6172,
    "placedGroups": 1627,
    "reservations": 1627,
    "avgParty": 3.5,
    "noshowRate": 1.1,
    "cancelRate": 4.36
  },
  {
    "name": "L'Osteria Köln Hahnenstraße",
    "normalizedName": "l'osteria köln hahnenstraße",
    "totalGroups": 970,
    "covers": 4073,
    "placedGroups": 912,
    "reservations": 912,
    "avgParty": 4.17,
    "noshowRate": 0.31,
    "cancelRate": 5.67
  },
  {
    "name": "L'Osteria Köln Lövenich",
    "normalizedName": "l'osteria köln lövenich",
    "totalGroups": 1858,
    "covers": 8206,
    "placedGroups": 1716,
    "reservations": 1716,
    "avgParty": 4.44,
    "noshowRate": 0,
    "cancelRate": 7.64
  },
  {
    "name": "L'Osteria Köln Mülheim",
    "normalizedName": "l'osteria köln mülheim",
    "totalGroups": 895,
    "covers": 3574,
    "placedGroups": 813,
    "reservations": 813,
    "avgParty": 3.99,
    "noshowRate": 1.79,
    "cancelRate": 7.37
  },
  {
    "name": "L'Osteria Köln Nippes",
    "normalizedName": "l'osteria köln nippes",
    "totalGroups": 557,
    "covers": 2829,
    "placedGroups": 499,
    "reservations": 499,
    "avgParty": 5.12,
    "noshowRate": 0,
    "cancelRate": 10.41
  },
  {
    "name": "L'Osteria Köln Zollhafen",
    "normalizedName": "l'osteria köln zollhafen",
    "totalGroups": 1468,
    "covers": 6357,
    "placedGroups": 1363,
    "reservations": 1363,
    "avgParty": 4.23,
    "noshowRate": 1.84,
    "cancelRate": 5.31
  },
  {
    "name": "L'Osteria Langenfeld",
    "normalizedName": "l'osteria langenfeld",
    "totalGroups": 1929,
    "covers": 8545,
    "placedGroups": 1737,
    "reservations": 1737,
    "avgParty": 4.44,
    "noshowRate": 1.71,
    "cancelRate": 8.24
  },
  {
    "name": "L'Osteria Marl Herzlia Allee",
    "normalizedName": "l'osteria marl herzlia allee",
    "totalGroups": 1653,
    "covers": 6288,
    "placedGroups": 1558,
    "reservations": 1558,
    "avgParty": 3.73,
    "noshowRate": 0.18,
    "cancelRate": 5.57
  },
  {
    "name": "L'Osteria Piccola Wachtberg",
    "normalizedName": "l'osteria piccola wachtberg",
    "totalGroups": 175,
    "covers": 703,
    "placedGroups": 163,
    "reservations": 163,
    "avgParty": 4.01,
    "noshowRate": 0,
    "cancelRate": 6.86
  },
  {
    "name": "L'Osteria Saarbrücken - Trierer Straße",
    "normalizedName": "l'osteria saarbrücken - trierer straße",
    "totalGroups": 1209,
    "covers": 5029,
    "placedGroups": 1068,
    "reservations": 1068,
    "avgParty": 4.12,
    "noshowRate": 0.08,
    "cancelRate": 11.58
  },
  {
    "name": "L'Osteria Saarbrücken Zinzinger Straße",
    "normalizedName": "l'osteria saarbrücken zinzinger straße",
    "totalGroups": 1947,
    "covers": 7663,
    "placedGroups": 1782,
    "reservations": 1782,
    "avgParty": 3.72,
    "noshowRate": 1.23,
    "cancelRate": 7.24
  },
  {
    "name": "L'Osteria Siegen",
    "normalizedName": "l'osteria siegen",
    "totalGroups": 1787,
    "covers": 6274,
    "placedGroups": 1648,
    "reservations": 1648,
    "avgParty": 3.5,
    "noshowRate": 0.67,
    "cancelRate": 7.11
  },
  {
    "name": "L'Osteria Trier",
    "normalizedName": "l'osteria trier",
    "totalGroups": 1432,
    "covers": 6587,
    "placedGroups": 1298,
    "reservations": 1298,
    "avgParty": 4.44,
    "noshowRate": 0,
    "cancelRate": 9.36
  },
  {
    "name": "L'Osteria Troisdorf",
    "normalizedName": "l'osteria troisdorf",
    "totalGroups": 1893,
    "covers": 8595,
    "placedGroups": 1682,
    "reservations": 1682,
    "avgParty": 4.59,
    "noshowRate": 1.69,
    "cancelRate": 9.46
  },
  {
    "name": "L'Osteria Wuppertal",
    "normalizedName": "l'osteria wuppertal",
    "totalGroups": 722,
    "covers": 3101,
    "placedGroups": 629,
    "reservations": 629,
    "avgParty": 4.2,
    "noshowRate": 3.88,
    "cancelRate": 9
  }
];

export const OPENTABLE_COHORT: OpenTableCohortAggregate = {
  "outletCount": 47,
  "covers": 250803,
  "placedGroups": 56648,
  "reservations": 56648,
  "avgParty": 4.43,
  "noshowRate": 1.17,
  "cancelRate": 7.33
};

export const OPENTABLE_GROUP_NAME = 'OpenTable outlets';

/** Normalize restaurant names for fleet matching (apostrophe-tolerant). */
export function normalizeOpenTableName(name: string): string {
  return name
    .replace(/[\u00b4\u2018\u2019'`]/g, "'")
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

export function openTableOutletByNormalizedName(): Map<string, OpenTableOutletAggregate> {
  return new Map(OPENTABLE_OUTLETS.map(o => [o.normalizedName, o]));
}

export function matchFleetRestaurantsToOpenTable(
  fleet: { id: string; name: string }[],
): { id: string; name: string; aggregate: OpenTableOutletAggregate }[] {
  const byName = openTableOutletByNormalizedName();
  const matched: { id: string; name: string; aggregate: OpenTableOutletAggregate }[] = [];
  for (const r of fleet) {
    const key = normalizeOpenTableName(r.name);
    const aggregate = byName.get(key);
    if (aggregate) {
      matched.push({ id: r.id, name: r.name, aggregate });
    }
  }
  return matched;
}
